import {TState} from './reducer'

export const selectTimeSession = ({timeSession}: {timeSession: TState}) =>
  timeSession.timeSession
export const selectTicketType = ({timeSession}: {timeSession: TState}) =>
  timeSession.ticketType
